import { Badge } from "@/components/ui/Badge";
import type { Ring } from "@/api/types";
import { RETIRED_RINGS } from "@/lib/rings";

/** The ring as a pill: Adopt/Trial read as settled, Hold/Deprecated as a warning, the rest neutral. */
export function RingBadge({ ring }: { ring: Ring | null }) {
  if (!ring) return <Badge>unrated</Badge>;
  const tone = ring === "Adopt" || ring === "Trial" ? "accent" : RETIRED_RINGS.includes(ring) ? "warn" : "neutral";
  return <Badge tone={tone}>{ring}</Badge>;
}
